exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".frame-docx {\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 0;\r\n}\r\n\r\n.modal-body {\r\n  margin: 0;\r\n  padding: 0;\r\n  height: 80vh;\r\n}\r\n\r\n.document-state {\r\n  padding: 1.25rem;\r\n  overflow-wrap: break-word;\r\n}\r\n\r\n.document-state button {\r\n  white-space: normal;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/views/view-docx/view-docx.component.css
// module id = ../../../../../src/app/content-page/views/view-docx/view-docx.component.css
// module chunks = main